// src/components/AddSupplyForm.js
import React, { useState } from 'react';
import { Box, Typography, TextField, Button, MenuItem, Card, CardContent, Stack } from '@mui/material';
import { useNavigate } from "react-router-dom";
import tutorialImage from "../assets/factura.png"
const AddSupplyForm = ({
  onSubmit,
  initialValues = { cliCod: '', sumNro: '', docTipo: '', docNumero: '' },   
tutorialTitle = "Dónde encontrar los datos en tu factura",
  tutorialText = "Mirá este ejemplo de factura para identificar rápidamente los campos que tenés que completar y poder registrar tu suministro sin errores.",
  submitLabel = "Guardar",
  cancelLabel = "Volver",
  cancelCallback
}) => {
  const navigate = useNavigate();
  const [cliCod, setCliCod] = useState(initialValues.cliCod);
  const [sumNro, setSumoNro] = useState(initialValues.sumNro);
  const [docTipo, setDocTipo] = useState(initialValues.docTipo);
  const [docNumero, setDocNumero] = useState(initialValues.docNumero);

  const handleSubmit = async () => {
    if (!cliCod || !sumNro || !docTipo || !docNumero) return;
    await onSubmit({ cliCod, sumNro, docTipo, docNumero });

    // Limpiar campos
    setCliCod('');
    setSumoNro('');
    setDocTipo('');
    setDocNumero('');
  };

  return (
    <Box p={3} maxWidth={900} mx="auto">
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
        Agregar{' '}
        <Box component="span" sx={{ color: '#64AE37', fontWeight: 'bold' }}>
          Suministro
        </Box>
      </Typography>

      <Card sx={{ borderRadius: 3, boxShadow: 4 }}>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 3,
            alignItems: { xs: 'center', md: 'flex-start' }
          }}
        >
          {/* Descripción + Imagen */}
          <Box flex={3} display="flex" flexDirection="column" justifyContent="space-between">
            <Box>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                {tutorialTitle}
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={2}>
                {tutorialText}
              </Typography>
            </Box>
            {tutorialImage && (
              <Box
                component="img"
                src={tutorialImage}
                alt="Ejemplo de factura"
                sx={{
                  width: '100%',
                  borderRadius: 2,
                  objectFit: 'cover',
                  flexShrink: 0
                }}
              />
            )}
          </Box>

          {/* Formulario */}
          <Box flex={2} display="flex" flexDirection="column" justifyContent="space-between"   sx={{ width: { xs: '100%', sm: '80%', md: 'auto' } }}
>
      <Typography variant="h6"  mb={1}>
        Agregar un suministro
    </Typography>
            <Stack spacing={2}>
              <TextField
                label="Nro de socio"
                value={cliCod}
                onChange={(e) => setCliCod(e.target.value)}
                fullWidth
              />
              <TextField
                label="Nro de suministro"
                value={sumNro}
                onChange={(e) => setSumoNro(e.target.value)}
                fullWidth
              />
              <TextField
                select
                label="Tipo de documento"
                value={docTipo}
                onChange={(e) => setDocTipo(e.target.value)}
                fullWidth
              >
                <MenuItem value="dni">DNI</MenuItem>
                <MenuItem value="cuit">CUIT</MenuItem>
                <MenuItem value="cuil">CUIL</MenuItem>
                <MenuItem value="pas">PAS</MenuItem>
                <MenuItem value="ciex">CI.EX</MenuItem>
                <MenuItem value="le">LE</MenuItem>
                <MenuItem value="lc">LC</MenuItem>
                <MenuItem value="ci">CI</MenuItem>
              </TextField>
              <TextField
                label="Nro de documento"
                value={docNumero}
                onChange={(e) => setDocNumero(e.target.value)}
                fullWidth
              />

              <Box display="flex" justifyContent="space-between" mt={2}>
                <Button 
                  variant="outlined" 
                  color="secondary"
                  onClick={cancelCallback || (() => navigate("/missuministros"))}
                >
                  {cancelLabel}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  {submitLabel}
                </Button>
              </Box>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AddSupplyForm;
